// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {} from "@/lib/logger";
import App from "./App.tsx";
import "./index.css";

console.log(`[Vite] Mode: ${import.meta.env.MODE}`);

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <App />,
  // </StrictMode>,
);
